export default {
  computed: {
    codigoUnimedUsuarioMixin() {
      return this.$store.getters.getObjetoUsuario.cdUnimed;
    },
    nomeUsuarioMixin() {
      return this.$store.getters.getObjetoUsuario.nome;
    },
    emailUsuarioMixin() {
      return this.$store.getters.getObjetoUsuario.email;
    },
    unimedSelecionadaNomeMixin() {
      return this.$store.getters.getObjetoUsuario.nomeUnimed;
    },
    /**
     * @return { { chave: String, descricao: String } }
     */
    papelUsuarioMixin() {
      return this.$store.getters.getObjetoUsuario.papel;
    }
  }
};
